<template>
	<template v-if="data">
		<section>
			<ButtonBack />

			<h1>{{ data.user.firstName }} {{ data.user.lastName }}</h1>

			<TheBox :title="'Werberatsentscheidung Infos'" :hasDataGrid="true">
				<el-row>
					<el-col :sm="12" :xs="24">
						<el-form-item label="WR-Entsch. bis:" prop="voteEndDate">
							<span>{{ data.case.voteEndDate ? $formatDate(data.case.voteEndDate) : '-' }}</span>
						</el-form-item>

						<el-form-item label="Entscheidungs-Datum:" prop="decidedDate">
							<span>{{ data.case.decidedDate ? $formatDate(data.case.decidedDate) : '-' }}</span>
						</el-form-item>
					</el-col>

					<el-col :sm="12" :xs="24">
						<el-form-item label="ID:" prop="hid">
							<span>{{ data.hid }}</span>
						</el-form-item>
					</el-col>
				</el-row>
			</TheBox>

			<TheBox :title="'Entscheidung'">
				<DetailsUserDecision :decisionCategories="data.categories" :decisionState="data.decisionState" />
			</TheBox>

			<TheBox :title="'Begründung:'">
				<div class="text">{{ data.reasonText }}</div>
			</TheBox>
		</section>

		<section>
			<h2>Fall</h2>

			<CasesTable :tableData="[data.case]" :totalCount="1" @loadNextPage="null" :mobileBox="true" />
		</section>
	</template>
	<section v-else-if="loading === false">
		<ButtonBack />
		<el-alert :title="texts.general.emptyText" type="error" effect="dark" :closable="false" />
	</section>
</template>

<script lang="ts">
import CasesTable from '@/components/tables/CasesTable.vue';
import { getDecision } from '@/requests/decisions';
import { Delete, Plus } from '@element-plus/icons-vue';
import { ElLoading, LoadingOptionsResolved } from 'element-plus';
import { defineComponent } from 'vue';
import saveIcon from '../assets/icons/saveIcon.vue';
import ButtonBack from '../components/buttons/ButtonBack.vue';
import ButtonSticky from '../components/buttons/ButtonSticky.vue';
import TheBox from '../components/TheBox.vue';
import TheButton from '../components/TheButton.vue';
import DetailsUserDecision from '../views/sections/DetailsUserDecision.vue';
import { CaseState, Category, CategoryResponse, DecisionResponse, DecisionState, Gender, LinkType, UserStatus } from '../types/types';
import { texts } from '../utils/texts';
import { categories } from '@/utils/categories';
import { startLoading, stopLoading } from '@/utils/loading/loadingHandler';
const ElMessageDuration = 3000;

export default defineComponent({
	name: 'EntscheidungDetailView',
	data() {
		return {
			data: null as DecisionResponse | null,
			loading: true,
			categories,
		};
	},
	props: {
		id: {
			type: String,
			required: true,
		},
	},
	components: {
		ButtonBack,
		ButtonSticky,
		TheButton,
		TheBox,
		CasesTable,
		Plus,
		Delete,
		saveIcon,
		DetailsUserDecision,
	},
	computed: {
		texts() {
			return texts;
		},
	},
	methods: {
		async loadDecision() {
			const loading = startLoading('#entscheidung');

			const result = await getDecision(this.id);
			if (result.success) {
				this.data = result.data;
			}

			this.loading = false;
			stopLoading(loading);
		},
	},
	mounted() {
		this.loadDecision();
	},
});
</script>
